import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { FitnessSession, FitnessSessionsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class FitnessSessionsDataService {

  private uri: string = `${environment.apiUrl}fitness-sessions`;
  private cacheKey: string = 'fitnessSessions.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getFitnessSession(id: number): Observable<FitnessSession|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getFitnessSessions(parameters: {[param: string]: string | string[]}): Observable<FitnessSessionsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addFitnessSession(data: FitnessSession): Observable<FitnessSession|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addFitnessSessions(data: FitnessSession[]): Observable<FitnessSession[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateFitnessSession(data: FitnessSession): Observable<FitnessSession|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateFitnessSessions(data: FitnessSession[]): Observable<FitnessSession[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchFitnessSession(data: FitnessSession): Observable<FitnessSession|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchFitnessSessions(data: FitnessSession[]): Observable<FitnessSession[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteFitnessSession(data: FitnessSession): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteFitnessSessions(data: FitnessSession[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((fitnessSession) => {
      ids.push(fitnessSession.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
